export default {
  fobtrading: {
    menuItem: "FOB Trading — Operación",
    pageTitle: "Operación",
    quickSearchPlaceholder: "Buscar operación por texto…",
    subtitle:
      "Negociación, proforma y shippings en un solo lugar más claro.",
    landingTitle: "FOB Trading — Operación",
    landingHint:
      "Abrí una operación agregando el id de proforma a la ruta, por ejemplo /operacion/ y el id, o desde el registro de la proforma.",
    listOpenOperacionView: "Vista operación",
    goProforms: "Ir a proformas",
    loadError: "No se pudo cargar la operación.",
    proforma: "Proforma",
    negotiation: "Negociación",
    shippings: "Shippings",
    openFullEdit: "Abrir edición completa",
    noNegotiation: "Esta proforma no tiene negociación vinculada.",
    noShippings: "Aún no hay shippings vinculados.",
    shippingName: "Nombre",
    tabNegotiation: "Negociación",
    tabProformShipping: "Proforma y shippings",
    tabDocsLogistics: "Documentos y logística",
    tabFinancialDashboard: "Panel operativo",
    tabCashResult: "Resultado",
    tabOperationBalance: "Balance de la operación",
    tabNegotiationHelp:
      "Revisá o editá la negociación que originó esta proforma.",
    tabProformHelp:
      "Editá la proforma y cada shipping con los mismos formularios que en el resto del sistema.",
    tabDocsHelp:
      "Los mismos PDF que en la ficha de la proforma y de cada shipping: vistas públicas y Admin Links.",
    noPdfDocuments:
      "Este tenant no tiene PDF configurados (vistas públicas ni Admin Links) para la proforma ni para los shippings.",
    pdfDocuments: "Documentos PDF",
    pdfDocumentsHint:
      "Mismos enlaces que en la ficha del registro (CustomLinks: vista y listado). Se abren en una pestaña nueva.",
    collectionsSnapshotUnavailable:
      "No se pudo cargar el panel operativo de esta proforma. Revisá permisos de finanzas o volvé a intentar.",
    tabCashHelp:
      "Balance consolidado y márgenes de resultado. El panel operativo (otra pestaña) concentra cobros por etapas y pagos a proveedor por embarque.",
    collectionsAdvanceGuidanceTitle: "Resumen de cobros de la operación",
    shippingInvoicesPendingHint:
      "Facturas de embarque: queda por cobrar {total} en {count} embarque(s) (saldo de factura tras adelanto de proforma y notas de crédito aplicables).",
    shippingInvoiceCollectTitle: "Cobros pendientes",
    shippingInvoiceCollectSubtitle:
      "Por factura de embarque: total facturado, ya cobrado (incluye la parte de adelanto de proforma imputada a esta factura) y saldo pendiente.",
    shippingInvoiceColInvoiceTotal: "Total factura",
    shippingInvoiceColCollected: "Cobrado",
    shippingInvoiceColRemaining: "Pendiente",
    shippingInvoiceColCreditNotesHint: "Notas de crédito: −{amount}",
    shippingInvoiceColActions: "Acción",
    shippingInvoiceCollectSingle: "Cobrar esta factura",
    shippingInvoiceCollectAll: "Cobrar todas en un solo cobro (appliedto por embarque)",
    receiveAdvanceCollection: "Cobrar adelanto",
    collectionsNoCollectPermission:
      "No tenés permiso para registrar cobros. Se requiere finanzas (cobros) o administración de finanzas.",
    financialNeedsModule:
      "No hay acceso al módulo Finanzas o no está activo. Activá Finanzas y el rol correspondiente para ver el panel operativo y la pestaña de resultado aquí.",
    shippingBlockTitle: "Shipping",
    expensesLinked: "Gastos",
    amount: "Importe",
    totalAppliedTo: "Total aplicado",
    paymentRemainingToApply: "Pendiente de aplicar",
    remaining: "Pendiente",
    shipping: "Shipping",
    paid: "Pagado",
    payPayment: "Pagar",
    markAsPaid: "Marcar como pagado",
    pending: "Pendiente",
    noPaymentsForProform: "No hay pagos registrados para esta proforma.",
    openRecordNewTab: "Abrir en nueva pestaña",
    paymentsAll: "Pagos",
    collections: "Cobros",
    clientSide: "Cliente",
    supplierSide: "Proveedor",
    invoices: "Facturas",
    invoice: "Factura",
    collected: "Cobrado",
    balance: "Saldo",
    margins: "Márgenes",
    projectedMargin: "Margen proyectado",
    realMargin: "Margen real",
    currentMargin: "Margen actual",
    projectedMarginHelp: "Margen bruto de la negociación, con el interés estimado reemplazado por el de la operación: proyectado a hoy mientras falte cobrar, real cuando entra el último cobro.",
    realMarginHelp:
      "Margen actual menos pagos pendientes: además de lo ya pagado, también descuenta los pagos pedidos que todavía no se marcaron como pagados.",
    projectedMarginHelpProform:
      "Total de la proforma menos los gastos cargados en la misma proforma (factura del proveedor, flete, comisiones…).",
    projectedMarginHelpDefault: "Total de la proforma menos los costos estimados del embarque.",
    realMarginHelpDefault: "Total facturado al cliente menos los costos estimados del embarque.",
    currentMarginHelp:
      "Foto de hoy en caja: cobrado al cliente menos pagos ya marcados como pagados.",
    expected: "Esperado",
    toCollect: "Por cobrar",
    yes: "Sí",
    no: "No",
    appliedToExpenses: "Aplicado a gastos",
    collectStatus: "Estado",
    collectedState: "Cobrado",
    requestPayment: "Pedir pago",
    requestFullPayment: "Pedir pago completo",
    requestAdvancePayment: "Pedir adelanto",
    invalidExpenseForPayment:
      "No se puede pedir el pago: falta el identificador del gasto.",
    invalidShippingForAdvancePayment:
      "No se puede pedir el adelanto: no se encontró el shipping vinculado al gasto.",
    paymentCreatedSuccessTitle: "Listo",
    paymentCreatedSuccessBody: "Se creó el pedido de pago correctamente.",
    negotiationExpenses: {
      button: "Cargar gastos de la negociación",
      confirmTitle: "¿Cargar los gastos de la negociación?",
      confirmText:
        "Se crean en {shipping}, cada uno ya pagado con su pago, igual que al crear una operación desde una negociación:",
      confirmButton: "Cargar",
      cancelButton: "Cancelar",
      doneTitle: "Gastos cargados",
      nothingToLoad: "La operación ya tiene todos los gastos de la negociación.",
      nothingPendingTitle: "No hay gastos para traer",
      noNegotiation:
        "Esta operación no se creó desde una negociación, así que no hay gastos de negociación para cargar.",
      loadError: "No se pudieron cargar los gastos de la negociación.",
    },
    realInterest: {
      title: "Costo financiero",
      help: "El interés de la negociación se estima con días supuestos. El de la operación usa los días entre los pagos de la mercadería y del flete y el cobro de la factura al cliente (promedio de fechas ponderado por monto, de cada lado; lo cobrado por encima de la factura, como un gasto que se le recobra, no cuenta): valor de venta × tasa × días / 365. Mientras falte cobrar se proyecta a hoy; al entrar el último cobro queda el real y el gasto Interest se ajusta solo. Si el cobro llega antes que el pago, el interés es 0.",
      estimated: "Estimado (negociación)",
      projected: "Proyectado (a hoy)",
      real: "Real (pagos y cobros)",
      days: "Días",
      interest: "Interés",
      rate: "Tasa anual",
      base: "Valor de venta",
      paymentAvgDate: "Pago promedio",
      collectAvgDate: "Cobro promedio del cliente",
      currentExpense: "Gasto Interest cargado",
      noExpense: "Sin gasto Interest",
      negativeDays: "El cobro llegó {days} días antes que el pago: el interés queda en 0.",
      provisional: "Provisorio: falta cobrar {amount}. Lo pendiente cuenta como si se cobrara hoy, así que el interés sube cada día de demora.",
      applied: "El gasto Interest ya quedó en el interés real: se ajustó solo con el último cobro.",
      loadError: "No se pudo calcular el interés real.",
      noPaymentYet: "Todavía no se pagó la mercadería ni el flete: vale el estimado de la negociación.",
      marginEffect: "Efecto en el margen proyectado",
      notApplied: "No se pudo ajustar solo el gasto Interest:",
      provisionalNoAmount: "Provisorio hasta que entre el último cobro.",
      blockers: {
        no_negotiation: "La operación no tiene negociación vinculada.",
        no_rate: "La negociación no tiene tasa de interés.",
        no_base: "La negociación no tiene valor de venta.",
        no_shipping: "La operación no tiene embarque.",
        multiple_shippings: "La operación tiene más de un embarque y no hay regla para repartir el interés.",
        no_payments: "No hay pagos de la mercadería ni del flete marcados como pagados.",
        no_collects: "No hay cobros del cliente.",
        mixed_currency: "Los pagos o los cobros están en monedas distintas.",
        not_fully_collected: "Todavía no entró el último cobro.",
        duplicated_expense: "El embarque tiene más de un gasto Interest.",
        expense_edited: "El gasto Interest tiene pagos cargados a mano: ajustalo desde el gasto.",
        expense_in_accounting: "El pago del gasto Interest ya entra en contabilidad: ajustalo desde el pago.",
      },
    },
  },
};
